module.exports = __webpack_public_path__ + "static/media/WhatIfINeedHelp_animation.b7a46d6a.gif";